
    <div #imagewrapper style="height: 100%;">
      <ngx-imageviewer [src]="fileblob" [width]="canvasDim.width" [height]="canvasDim.height"></ngx-imageviewer>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/file.view.image.component.ts.FileViewImageComponent.html